/* eslint-disable @angular-eslint/no-output-native */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DotBounceLoadingEffectModule } from '../dot-bounce-loading-effect/dot-bounce-loading-effect.module';

@Component({
	selector: 'msp-button',
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule],
	templateUrl: './msp-button.component.html',
	styleUrl: './msp-button.component.scss',
})
export class MspButtonComponent {
	@Input() label = '';
	@Input() disabled = false;
	@Input() loading = false;
	@Input() style: 'primary' | 'success' | 'warning' | 'danger' = 'primary';
	@Output() click = new EventEmitter<Event>();
}
